
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/browse/job-category",
      function () {
        return require("private-next-pages/browse/job-category.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/browse/job-category"])
      });
    }
  